import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import GoogleAddressVerify from "./../../google-address-verify/GoogleAddressVerify";
import { withValidation } from "../hocs/WithValidation";

export const fields = {
  CITY: "city",
  STATE: "state",
  STREET_ADDRESS: "streetAddress",
  ZIP: "zip",
  ADDRESS_VERIFICATION_PROVIDER: "addressVerificationProvider"
};

class GoogleAddressInput extends Component {
  componentDidMount() {
    this.registerElement(fields.CITY);
    this.registerElement(fields.STATE);
    this.registerElement(fields.STREET_ADDRESS);
    this.registerElement(fields.ZIP);
    this.props.context.registerFormElement({
      value: "google",
      name: fields.ADDRESS_VERIFICATION_PROVIDER,
      valid: true
    });
    const { selectedAddress } = this.props;
    if (selectedAddress && _.keys(selectedAddress).length) {
      this.handleGAChange(selectedAddress);
    }
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  registerElement(name) {
    this.props.context.registerFormElement({
      value: null,
      name,
      valid: false,
      validate: this.props.handleValidation,
      specialParser: e => e.target.gaResponse
    });
  }

  handleGAChange(response) {
    this.handleFieldChange(fields.CITY, response);
    this.handleFieldChange(fields.STREET_ADDRESS, response);
    this.handleFieldChange(fields.ZIP, response);
    /**
     * This must go last since it has a unique validation.
     * There is an issue with WithValidation and it can't handle mulitple updates.
     * If an error is registered through updateFormElement, and a success comes after, the error gets deleted.
     * So after the first error occurs, it's going to be displayed, and not update anything after
     */
    this.handleFieldChange(fields.STATE, response);
  }

  handleFieldChange(name, response) {
    const { handleChange, context } = this.props;
    const event = {
      target: {
        value: response[name],
        name,
        gaResponse: response
      },
      type: "blur"
    };
    handleChange(event, context);
  }

  render() {
    const { helper, wrapperCssClasses } = this.props;
    return (
      <div className={wrapperCssClasses}>
        <GoogleAddressVerify
          helper={helper}
          onChange={response => this.handleGAChange(response)}
          {...this.props}
        />
      </div>
    );
  }
}

GoogleAddressInput.defaultProps = {
  hideLabel: true
};

GoogleAddressInput.propTypes = {
  handleValidation: PropTypes.func.isRequired,
  hideLabel: PropTypes.bool
};

export default withValidation(GoogleAddressInput);
